import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

const usersQuery = gql`
query MyQuery($name: String!){
  searchUsersByName(name: $name){
    error
    firstname
    id
    identityId
    lastname
    picture
    userType
    companyName
    vatNumber
    address
  }
}`;

const friendListQuery = gql`
query MyQuery {
  getFriends {
    friends {
      error
      firstname
      id
      identityId
      lastname
      picture
      userType
      companyName
      vatNumber
      user_level {
        user_level
      }
    }
    totalFriends
  }
}`;

const pendingRequestsQuery = gql`
query MyQuery {
  getPendingFriendRequests {
    user_id
    is_sent
    date
    user {
      picture
      lastname
      id
      firstname
      error
      identityId
      companyName
      userType
      vatNumber
      user_level {
        user_level
      }
    }
  }
}`;

const addFriendQuery = gql`
mutation MyMutation($friend_id: ID!){
  addFriend(friend_id: $friend_id)
}
`;

const removeFriendQuery = gql`
mutation MyMutation($friend_id: ID!){
  removeFriend(friend_id: $friend_id)
}
`;

const answerFriendRequestQuery = gql`
mutation MyMutation($friend_id: ID!, $accepted: Boolean!){
  answerFriendRequest(friend_id: $friend_id, accepted: $accepted)
}
`;

const withdrawFriendQuery = gql`
mutation MyMutation($friend_id: ID!){
  withdrawFriendRequest(friend_id: $friend_id)
}
`;

import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FriendsService {
  updateFriendList$ = new Subject();
  constructor(private apollo: Apollo) { }

  getUserByName(searchedText) {
    const users = this.apollo.watchQuery<any>({
      // fetchPolicy: "no-cache",
      query: usersQuery,
      variables: {
        name: searchedText
      }
    });
    return users;
  }

  getFriendList() {
    const friends = this.apollo.watchQuery<any>({
      fetchPolicy: "network-only",
      query: friendListQuery
    });
    return friends;
  }

  sendFriendRequest(friend_id) {
    this.apollo.mutate<any>({
      mutation: addFriendQuery,
      variables: {
        friend_id: friend_id

      },

    }).subscribe(({ data }) => {
      this.getPendingFriendRequestList().valueChanges.subscribe();
    }, (error) => {
      console.log('there was an error sending the query', error);
    })
  }

  answerFriendRequests(friend_id, accepted) {
    this.apollo.mutate<any>({
      mutation: answerFriendRequestQuery,
      variables: {
        friend_id: friend_id,
        accepted: accepted

      },

    }).subscribe(({ data }) => {
      this.getPendingFriendRequestList().valueChanges.subscribe();
      this.getFriendList().valueChanges.subscribe();
    }, (error) => {
      console.log('there was an error sending the query', error);
    })
  }

  withdrawFriendRequest(friend_id) {
    return this.apollo.mutate<any>({
      mutation: withdrawFriendQuery,
      variables: {
        friend_id: friend_id

      }
    })
    // .subscribe(({ data }) => {
    //   this.getPendingFriendRequestList().valueChanges.subscribe();
    // }, (error) => {
    //   console.log('there was an error sending the query', error);
    // })
  }

  removeFriendRequest(friend_id) {
    return this.apollo.mutate<any>({
      mutation: removeFriendQuery,
      variables: {
        friend_id: friend_id
      }
    });
  }

  getPendingFriendRequestList() {
    const friendRequests = this.apollo.watchQuery<any>({
      fetchPolicy: "network-only",
      query: pendingRequestsQuery
    });
    return friendRequests;
  }

}
